export const relationshipMap: Record<string, string[]> = {
  BOYFRIEND: ['whos-it-for-boyfriend'],
  BROTHER: ['whos-it-for-brother'],
  BROTHER_IN_LAW: ['whos-it-for-brother-in-law'],
  MALE_COLLEAGUE: ['for-him'],
  MALE_COUSIN: ['for-him'],
  DAD: ['whos-it-for-dad'],
  FIANCE: ['whos-it-for-fiance'],
  MALE_FRIEND: ['for-him'],
  GODSON: ['whos-it-for-godson'],
  GRANDAD: ['whos-it-for-grandad'],
  GRANDSON: ['whos-it-for-grandson'],
  HUSBAND: ['whos-it-for-husband'],
  UNCLE_NEPHEW: ['whos-it-for-nephew'],
  SON: ['whos-it-for-son'],
  MALE_TEACHER: ['for-him'],
  UNCLE: ['whos-it-for-uncle'],
  AUNTIE: ['whos-it-for-auntie'],
  FEMALE_COLLEAGUE: ['for-her'],
  FEMALE_COUSIN: ['for-her'],
  DAUGHTER: ['whos-it-for-daughter'],
  FIANCEE: ['whos-it-for-fiancee'],
  FEMALE_FRIEND: ['for-her'],
  GIRLFRIEND: ['whos-it-for-girlfriend'],
  GODDAUGHTER: ['whos-it-for-goddaughter'],
  GRANDDAUGHTER: ['whos-it-for-granddaughter'],
  GRANNY: ['grandma'],
  MUM: ['whos-it-for-mum'],
  NIECE: ['whos-it-for-niece'],
  SISTER: ['whos-it-for-sister'],
  SISTER_IN_LAW: ['whos-it-for-sister-in-law'],
  FEMALE_TEACHER: ['for-her'],
  WIFE: ['whos-it-for-wife'],
  AUNTIEUNCLE: ['whos-it-for-couple'],
  BROTHER_SISTERINLAW: ['brother-and-partner'],
  DATING_COUPLE: ['partner'],
  DAUGHTER_SONINLAW: ['daughter-and-partner'],
  GRANNYGRANDAD: ['grandparents'],
  MARRIED_COUPLE: ['whos-it-for-couple'],
  MUMDAD: ['mum-and-dad'],
  NEWLY_WEDS: ['whos-it-for-couple'],
  SON_DAUGHTERINLAW: ['son-and-partner'],
  TWINS: ['whos-it-for-twins'],
}
